import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const ExternalApi = () => {
  const [message, setMessage] = useState("");
  const [customerId, setCustomerId] = useState("1");
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const awsApiBaseUrl = "https://{SUB_HERE}}.execute-api.us-east-1.amazonaws.com";

  const callApi = async (endpoint) => {
    if (!isAuthenticated) {
      setMessage("You must be logged in to call the API.");
      return;
    }
    try {
      const token = await getAccessTokenSilently({
        audience: "https://aws-api-gateway",
        scope: "openid profile email list:customers read:customers edit:customers",
        cacheMode: "off",
      });
      console.log("Access Token:", token);
      const response = await fetch(`${awsApiBaseUrl}${endpoint}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const responseData = await response.json();
      if (response.ok) {
        setMessage(JSON.stringify(responseData, null, 2));
      } else {
        setMessage(`Error: ${responseData.message || "Failed to fetch data"}`);
      }
    } catch (error) {
      console.error(`Error calling ${endpoint}:`, error);
      setMessage(`Error: ${error.message}`);
    }
  };

  const callListCustomers = () => callApi("/unicorns");
  const callGetCustomer = () => callApi(`/unicorn?name=Shopify`);

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-2xl mx-auto">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Secure Your API</h2>
      <p className="text-gray-600 mb-4">
        Demo calling AWS API Gateway endpoints using Auth0.
      </p>
      <div className="space-y-4">
        <button
          onClick={callListCustomers}
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
        >
          Get All Customers
        </button>
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <label className="flex flex-col w-full sm:w-1/3">
            <span className="text-gray-700 font-medium mb-1">Customer ID</span>
            <input
              type="text"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter customer ID"
            />
          </label>
          <button
            onClick={callGetCustomer}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
          >
            Get Customer by ID
          </button>
        </div>
      </div>
      {message && (
        <pre className="bg-gray-100 p-4 rounded-md mt-6 text-sm text-gray-800 overflow-auto">
          {message}
        </pre>
      )}
    </div>
  );
};

export default ExternalApi;